import React, { Component,Fragment } from 'react';
import { putToast, getObjects, adminloadTP,  tournamentRemoveRoundEvent, tournamentAddRoundEvent, tournamentUpdateRoundEvent, AuthenticatedUser, stopTimer } from "../../../api";
import TournamentPageTemplate from '../tournamentPageTemplate'
import RoundEventTemplateCube from '../cubes/config/roundEventTemplateCube';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import SelectSearch from 'react-select-search';
import '../../../pages/tSearchStyles.css';

const _ = require("lodash");

class TournamentConfigEvents extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onTemplateChange = this.onTemplateChange.bind(this);
        this.onAddToRound = this.onAddToRound.bind(this);
        this.onRemoveRoundEvent = this.onRemoveRoundEvent.bind(this);
        this.onEventDetails = this.onEventDetails.bind(this);

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            rid: params.rid,
            selectedEvent: null,
            selectedTemplate: "",
            selectedListId: null                     
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('tEvent').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            getObjects('promptList').then(d4 => {
                                if (d4 && d4.error) {
                                    console.log(d4.error);
                                } else {
                                    this.setState({ pid: pid, tData: d2.tournamentPage, tRound: d2.tournamentPage.rounds.find(x=>x._id === this.state.rid), tUsers: d2.tUsers, tEvents: d3, promptLists: d4, loading: false});                    
                                }
                            });
                        }
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    onTemplateDetails(selectedId) {
        this.setState({ selectedEvent: this.state.tData.events.find(x=>x._id === selectedId)});
    }

    onEventDetails(event) {   
        this.setState({ selectedEvent: event});
    }



    onValidSubmit = (event, values) => {
        const {selectedEvent} = this.state;
        if (!selectedEvent) return;
        const formData = new FormData(document.getElementById('mainForm'));
        formData.append('promptListId', this.state.selectedListId)

        if (this.state.selectedEvent.eventId) {
            tournamentUpdateRoundEvent(formData, this.state.selectedEvent._id, this.state.tRound._id, this.state.tData._id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);    
                    _.extend(selectedEvent, values);
                    this.setState({ tData: d2.tournamentPage, selectedEvent: selectedEvent, selectedTemplated: selectedEvent.template });  
                }
            });                     
        } 
    };
    

    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };
    
    onTemplateChange(ev) {
        this.setState({ selectedTemplate:  ev.target.value});   
    }

    onAddToRound(ev) {
        ev.preventDefault();
        const {selectedEvent } = this.state;
        const formData = new FormData(document.getElementById('mainForm'));
        formData.append('eventId', selectedEvent._id)
        formData.append('title', selectedEvent.title)
        formData.append('abbr', selectedEvent.abbr)
        formData.append('promptListId', this.state.selectedListId)

        tournamentAddRoundEvent(formData, this.state.tData._id, this.state.tRound._id).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ tData:  d2.tournamentPage, tRound: d2.tournamentPage.rounds.find(x=>x._id === this.state.rid)});   
            }
        });
    }

    onRemoveRoundEvent(ev) {
        ev.preventDefault();

        if (this.state.selectedEvent.eventId) {
            tournamentRemoveRoundEvent(this.state.selectedEvent._id, this.state.tRound._id, this.state.tData._id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ tData:  d2.tournamentPage, tRound: d2.tournamentPage.rounds.find(x=>x._id === this.state.rid)});   
                }
            });
        }
    }

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        this.form && this.form.reset()                   
/*
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
*/
    }

    render(){
        if (this.state.loading) { return null; }

        stopTimer();      
        const { tData, user, tRound, selectedEvent, promptLists } = this.state;

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Configuration - ${user.displayname}`} title3=""
            bcTitle="Round Events Configuration" bcParents={[
                {name: tData.title, url: `/tournament/config/${tData._id}`},
                {name: "Configure Rounds", url: `/tournament/config/rounds/${tData._id}`},
            ]} 
        >                     
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>{tRound.title} Events</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tRound.events.map((event, index) => 
                                    <div className="row" key={index}>
                                        <div key={index} className="col-12">
                                            <span key={index} onClick={() => this.onEventDetails(event)} style={{cursor: 'pointer'}}>
                                                <RoundEventTemplateCube key={index} tournament={tData} tEvent={event} user={user} tUser={null} />
                                            </span>
                                        </div>
                                    </div>
                                )} 
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;
                            </div>
                        </div> 


                    </div>
                    <div className="col-sm-6">                         

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Tournament Events</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tData.events.map((event, index) => 
                                    <button style={{margin: "4px"}} type="button" className="btn btn-warning" onClick={()=>this.onTemplateDetails(event._id)}>{event.abbr}</button>
                                )}                                                                         
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;                                
                            </div>
                        </div> 

                        <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={selectedEvent} ref={c => (this.form = c)}>
                            <div className="card" style={{marginBottom: "10px"}}>
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                    <h4>Round-Event Details
                                    {selectedEvent &&                            
                                    <>
                                    {selectedEvent.eventId && <button  className="btn btn-primary pull-right" type="submit" >Save</button>
                                    }
                                    {!selectedEvent.eventId && <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onAddToRound}>Add  </button>}
                                    {selectedEvent.eventId && <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onRemoveRoundEvent}>Remove  </button> }
                                    </>
                                    }
                                    </h4>     
                                </div>   
                                <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    {selectedEvent                         
                                    ?   <Fragment>    
                                            <AvField disabled label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                                            <AvField disabled label="Abbr" grid={{xs: 10}} name="abbr" id="abbr" type="text" />
                                        {selectedEvent.eventId &&
                                            <Fragment>
                                                <AvField label="Max Rooms" grid={{xs: 10}} name="maxRoomCount" id="maxRoomCount" type="text"/>
                                                <AvField label="Judge Count" grid={{xs: 10}} name="requiredJudgeCount" id="requiredJudgeCount" type="text" />                                          
                                                <AvField label="Panel Method" grid={{xs: 10}} name="panelMethod" id="panelMethod" type="select">                                 
                                                    <option disabled value="">Select Panel Method</option>                                 
                                                    <option value="random" key="random">Random</option>                                 
                                                    <option value="distributed" key="distributed">Distributed</option>                                                                                                                    
                                                    <option value="powerhh" key="powerhh">Power High High</option>                                                                                                                    
                                                    <option value="powerhl" key="powerhl">Power High Low</option>                                                                                                                    
                                                    <option value="elimination" key="elimination">Elimination</option>                                                                                                                    
                                                </AvField> 
                                                <div className="row form-group justify-content-start">
                                                    <label className="col-sm-2 col-form-label">Prompt List: </label>
                                                    <div className="col-xl-10">
                                                        <SelectSearch style={{width: '100%'}}
                                                            options={promptLists && promptLists.filter(x=>x.status === 'publish').map(pl => { return ({value: pl._id, name: pl.title })})}
                                                            search
                                                            placeholder="Select Prompt List Name"
                                                            onChange={ (value) => {
                                                                this.setState({ selectedListId: value })
                                                                }
                                                            }
                                                            value={selectedEvent.promptListId}
                                                        />
                                                    </div>
                                                </div>                                                 
                                                <AvField label="Offered Count" grid={{xs: 10}} name="offeredCount" id="offeredCount" type="text" />
                                                <AvField label="Strike Count" grid={{xs: 10}} name="strikeCount" id="strikeCount" type="text" />
                                                <AvField label="Offered Duration" grid={{xs: 10}} name="offeredDuration" id="offeredDuration" type="text" />
                                                <AvField label="Prep Duration" grid={{xs: 10}} name="prepDuration" id="prepDuration" type="text" />
                                                <AvField label="Prompt Mode" grid={{xs: 10}} name="promptMode" id="promptMode" type="select">                                 
                                                    <option disabled value="">Select Prompt Mode</option>                                 
                                                    <option value="random" key="random">Random</option>                                 
                                                    <option value="elimination" key="elimination">Elimination</option>                                                                                                                                                                                                                                       
                                                </AvField>                                             
                                            </Fragment>  
                                        }                              
                                        </Fragment>
                                    :   <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>No Event Selected</p>
                                    }
                                </div>
                                <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                    &nbsp;

                                </div>
                            </div> 
                        </AvForm>
                    </div>
                </div>  
            </div>
            </TournamentPageTemplate>
            
        )
    }
}

export default TournamentConfigEvents;